import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../environments/environment';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class SurveyAuthService {

  AUTH_API = environment.apiURL;
  
  constructor(private http: HttpClient) { }
  
  generate_OTP(postdataObj: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json'})
    };
    return this.http.post(this.AUTH_API + 'auth/surveyregister', 
    postdataObj
    , httpOptions);
  }

  verify_OTP(postdataObj: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json','Authorization': 'Bearer '+ localStorage.getItem('Token')})
    };
    return this.http.post(this.AUTH_API + 'survey/survey_email_otp_verification', 
    postdataObj
    , httpOptions);
  }

}